import React from 'react';
import ImgProfile from '../../../images/person1.jpg';

const Profile = () => {
    return (
        <div>
            <div className="card">
                <div className="card-image">
                    <img
                        className="activator"
                        src={ImgProfile}
                        alt="John Doe"
                    />
                    {/* <Link className="btn-floating halfway-fab waves-effect waves-light red">
                        <i className="material-icons activator">more_vert</i>
                    </Link> */}
                </div>
                <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                        Thắng NgHồng
                    </span>
                    <p>Fresher</p>
                    <hr />
                    <span>
                        <p
                            className="flex-container"
                            style={{ paddingTop: '10px' }}
                        >
                            <a href="https://www.facebook.com/hongthang.nguyen.3323/">
                                {' '}
                                <i className="fab fa-facebook-f grey-text text-darken-4 social_style"></i>
                            </a>
                            <a href="mailto:thangngh.00@gmail.com">
                                {' '}
                                <i className="fab fa-google-plus-g grey-text text-darken-4 social_style"></i>
                            </a>
                            <a href="https://github.com/thangngh">
                                <i className="fab fa-github grey-text text-darken-4 social_style"></i>
                            </a>
                        </p>
                    </span>
                </div>
            </div>
        </div>
    );
};
export default Profile;
